import "./assets/sass/style.scss";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import HomePage from "./views/homepage/HomePage";
import SellCarPage from "./views/seller/SellCar";
import PersonalInfo from "./views/account/PersonalInfo";
import AccountLayout from "./layouts/AccountLayout";
import ProtectedRoute from "./_utils/protectedRoute";
import AuthProvider from "./context/AuthContext";
import DefaultLayout from "./layouts/DefaultLayout";
import CarListingPage from "./views/car-listing/CarListingPage";
import CarViewPage from "./views/car-listing/CarViewPage";
import AboutUs from "./views/about_us/AboutUs";
import FAQ from "./views/faqs/FAQ";
import { ToastProvider } from "./context/ToastContext";
import MyFavorites from "./views/account/favorites";
import MyCars from "./views/account/myCars";
import { WishlistProvider } from "./context/WishlistContext";
import ScrollToTop from "./_utils/ScrollToTop";
import MyCarDetails from "./views/account/MyCarDetails";
import BuyingACar from "./views/faqs/BuyingCar";
import OwnershipTransfer from "./views/faqs/OwnershipTransfer";
import SellingCar from "./views/faqs/SellingCar";
import HowItWorks from "./views/faqs/HowItWorks";
import FeesAndCharges from "./views/faqs/FeesAndCharges";

const App = () => {
  return (
    <div className="App">
      <AuthProvider>
        <ToastProvider>
          <WishlistProvider>
            <BrowserRouter>
            <ScrollToTop />
              <Routes>
                {/* Public Pages */}
                <Route path="/" element={<DefaultLayout />}>
                {/*
                  <Route path="/" element={<HomePage />} />
                  */}
                  <Route path="/" element={<CarListingPage />} />
                  <Route path="/auctions" element={<CarListingPage />} />
                  <Route path="/auctions/:id" element={<CarViewPage />} />
                  <Route path="/aboutus" element={<AboutUs />} />
                  <Route path="/faq" element={<FAQ />}>
                    <Route path="buying-a-car" element={<BuyingACar />} />
                    <Route path="ownership-transfer" element={<OwnershipTransfer />} />
                    <Route path="selling-a-car" element={<SellingCar />} />
                    <Route path="how-it-works" element={<HowItWorks />} />
                    <Route path="fees-and-charges" element={<FeesAndCharges />} />
          
                 </Route>
                  {/* Protected Pages */}
                  <Route
                    path="/sell-car"
                    element={
                      <ProtectedRoute>
                        <SellCarPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/account/"
                    element={
                      <ProtectedRoute>
                        <AccountLayout />
                      </ProtectedRoute>
                    }
                  >
                    <Route path="profile" element={<PersonalInfo />} />
                    <Route path="favorites" element={<MyFavorites />} />
                    <Route path="my-listing" element={<MyCars />} />
                    <Route path="my-listing/:id" element={<MyCarDetails />} />
                  </Route>
                </Route>
              </Routes>
            </BrowserRouter>
          </WishlistProvider>
        </ToastProvider>
      </AuthProvider>
    </div>
  );
};

export default App;
